module.exports = __webpack_public_path__ + "static/img/11.f4052e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/11.png
// module id = k6XJ
// module chunks = 0